import {autoinject} from "aurelia-framework";
import {PageMessageService} from "../../services/page-message-service";

@autoinject
export class PageMessage{

    constructor(public pageMessageService: PageMessageService) {
    }

}